import React from "react";
import "./OurProcess.css";
import process from "./IMG/Process.svg";
import Spro from "./IMG/Spro.svg";

const steps = [
  { title: "Understand the requirement", text: "Agree on role duties, essential skills, location, employment terms and hiring timeline." },
  { title: "Review relevant candidates", text: "Use the agreed criteria to assess applications and record job-related evidence." },
  { title: "Coordinate interviews", text: "Confirm interview stages, decision owners and candidate updates." },
  { title: "Confirm offer and joining", text: "Document the agreed terms, start date, required checks and onboarding handover." }
];
function OurProcess() {
  return (
    <section className="quarec-process-section" aria-labelledby="quarec-process-heading">
      <div className="quarec-process-inner">
        <h2 id="quarec-process-heading">Our recruitment process</h2>
        <p className="quarec-process-intro">The exact steps depend on the role and agreed service scope. These checkpoints help employers and candidates understand what happens next.</p>
        <ol className="quarec-process-steps">
          {steps.map((step, index) => <li key={step.title}><span>{index + 1}</span><div><h3>{step.title}</h3><p>{step.text}</p></div></li>)}
        </ol>
        <div className="quarec-process-visuals" aria-hidden="true"><img className="FV0722e" src={process} alt="" /><img className="BLOklk" src={Spro} alt="" /></div>
      </div>
    </section>
  );
}
export default OurProcess;
